<template>
  <div class="nav">
    <div class="little_header"></div>
    <b-navbar
      toggleable="lg"
      type="light"
      class="navbar_header navbar-light bg-light"
      variant="primary"
      :sticky="true"
    >
      <b-navbar-brand href="#" to="home" class="leftBrand">
        AbcGames
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <template v-for="item in menuLists">
            <b-dropdown-item :to="item.meta.path">
              <div class="txt">{{ item.name }}</div>
            </b-dropdown-item>
          </template>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
import routerLists from "../router/index";

export default {
  name: "",
  data() {
    return {
      menuLists: []
    };
  },
  created() {
    const arr = routerLists.options.routes;
    this.menuLists = arr.filter(item => item.meta.hide !== true);
  },
  methods: {
    goHome(name) {
      console.log("goHome");
      this.$router.push({
        name: "terms"
      });
    }
  }
};
</script>
<style scoped="scoped">
.leftBrand {
  font-family: "Franklin";
  color: #fff !important;
  font-size: 2.9vw;
}
.navbar_header {
  width: 100%;
  padding: 0;
  padding-left: 2vw;
  box-sizing: border-box;
}
.mt_5 {
  margin-top: 5px;
}
.bg-primary {
  background-color: #4699EB !important;
}
.little_header {
  width: 100%;
  height: 6px;
  background: #fad961;
}

@media (max-width: 991px) {
  .leftBrand {
    font-size: 3vw;
  }
  .navbar_header {
    padding: 1vw;
  }
  .navbar-nav li {
    padding: 0 5vw;
    box-sizing: border-box;
  }
}
@media (max-width: 800px) {
  .leftBrand {
    font-size: 4vw;
  }
  .navbar_header {
    padding: 3vw;
  }
  .navbar-nav li {
    padding: 0 5vw;
    box-sizing: border-box;
  }
}
@media (max-width: 600px) {
  .leftBrand {
    font-size: 5vw;
  }
  .navbar_header {
    padding: 1vw;
  }
  .navbar-nav li {
    padding: 0 5vw;
    box-sizing: border-box;
  }
}
@media (max-width: 460px) {
  .leftBrand {
    font-size: 5vw;
  }
  .navbar_header {
    padding: 3vw;
  }
  .navbar-nav li {
    padding: 0 5vw;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Head.vue